import Vue from 'vue'
import Router from 'vue-router'
// 首页
const Index = r => require.ensure([], () => r(require('@/view/index/Index')), '/index')
// 资质查询结果
const qualification = r => require.ensure([], () => r(require('@/view/qualification/Qualification')), 'qualifications')

// 域名查询结果
const domains = r => require.ensure([], () => r(require('@/view/domain/Domain')), 'domains')

// 资讯
const news = r => require.ensure([], () => r(require('@/view/news/News')), 'notices')

// 资讯
const newsDetail = r => require.ensure([], () => r(require('@/view/news/NewsDetail')), 'notices')

// 专题页
const specialPage = r => require.ensure([], () => r(require('@/view/specialPage/SpecialPage')), 'notices')

//直购易备案证书SDK跳转页面
const filingCertificate = r => require.ensure([], () => r(require('@/view/filingCertificate/filingCertificate')), 'filingCertificate')

//商品备案证书页
const ProRecordCer = r => require.ensure([], () => r(require('@/view/ProRecordCer/ProRecordCer')), 'ProRecordCer')

//产品信息溯源产品信息溯源证书页
const ProTraceabilityCer = r => require.ensure([], () => r(require('@/view/ProTraceabilityCer/ProTraceabilityCer')), 'ProTraceabilityCer')
Vue.use(Router)

export default new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/qualification',
            name: 'qualification',
            component: qualification
        },
        {
            path: '/domain',
            name: 'domain',
            component: domains
        },
        {
            path: '/news',
            name: 'news',
            component: news
        },
        {
            path: '/news/detail/:id',
            name: 'newsDetail',
            component: newsDetail
        },
        {
            path: '/specialPage',
            name: 'SpecialPage',
            component: specialPage
        },
        {
            path: '/filingCertificate',
            name: 'filingCertificate',
            component: filingCertificate
        },
        
        {
            path: '/ProRecordCer',
            name: 'ProRecordCer',
            component: ProRecordCer
        },
        {
            path: '/ProTraceabilityCer',
            name: 'ProTraceabilityCer',
            component: ProTraceabilityCer
        }   

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js